import * as firebase from "firebase";
import firebaseApp from  "./FirebaseApp";
export default {
  providers: {
    twitter: new firebase.auth.TwitterAuthProvider(),
    google: new firebase.auth.GoogleAuthProvider(),
    facebook: new firebase.auth.FacebookAuthProvider(),
    github: new firebase.auth.GithubAuthProvider()
  },
  user: null,
  ref: firebase.auth(),
  onAuth (authCallback) {
    this.ref.onAuthStateChanged(authCallback)
  },
  getAuth () {
    return this.ref.currentUser
  },
  loginWithPassword (credentials) {
    return this.ref.signInWithEmailAndPassword(credentials.email, credentials.password)
  },
  signUpWithPassword (credentials) {
    return this.ref.createUserWithEmailAndPassword(credentials.email, credentials.password)
  },
  signInWithProvider (providerName, callback) {
    let provider = this.providers[providerName]
    this.ref.signInWithPopup(provider).then((result) => {
      if (callback) {
        callback(null, result)
      }
    }, (error) => {
      callback(error)
    })
  },
  signOut () {
    this.ref.signOut()
  }
}


// WEBPACK FOOTER //
// ./src/data/Auth.js